exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-corner[data-v-c3db4ebc]{border-start-start-radius:20px;border-end-end-radius:20px}.balance-negative[data-v-c3db4ebc]{color:red;font-weight:700}.balance-positive[data-v-c3db4ebc]{color:green;font-weight:700}", ""]);

// exports
